<template>
    <component :is="tag" class="price-value">
        {{ $filters.energeticsPrettier(consumption) }}
        <sub><span v-if="consumption >= 1000">M</span><span v-else>k</span>Wh / rok</sub>
    </component>        
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    props: {
        consumption: {
            type: Number,
            required: true,
        },
        tag: {
            type: String,
            default: 'h1',
        }
    },
    computed: mapGetters(["getText"]),
}
</script>

<style lang="scss">
.price-value {
    text-align: center;
}
</style>